import { FEATURES } from '/src/features/_global/constants';

export const ADS_LIBRARY_PREVIEW_PERMISSIONS = {
  [FEATURES.ADS_LIBRARY_PREVIEW]: ({ capabilities }) => ({
    navigate: capabilities?.adsLibraryPreview?.permissions?.nav,
    view: capabilities?.adsLibraryPreview?.permissions?.view,
  }),
};
